import React from 'react';
import {
  Box,
  Paper,
  Typography
} from '@mui/material';
import {
  CalendarToday as CalendarIcon
} from '@mui/icons-material';
import BookingCard from './BookingCard';
import BookingSearch from './BookingSearch';

const BookingContent = ({
  bookings,
  showActions = true,
  isHistoryTab = false,
  searchTerm,
  onSearchChange,
  onUpdateStatus,
  onEdit,
  onDelete,
  onRejectWithReason,
  filterBookings
}) => {
  // Filter bookings if in history tab
  const filteredBookings = isHistoryTab ? filterBookings(bookings, searchTerm) : bookings;
  
  if (filteredBookings.length === 0) {
    return (
      <Box>
        {isHistoryTab && (
          <BookingSearch 
            searchTerm={searchTerm} 
            onSearchChange={onSearchChange} 
          />
        )}
        <Paper
          sx={{
            p: 4,
            textAlign: 'center',
            bgcolor: 'grey.50',
            borderRadius: 2,
            border: '2px dashed',
            borderColor: 'grey.300'
          }}
        >
          <CalendarIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {isHistoryTab && searchTerm ? 'Aucun résultat' : 'Aucune réservation'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {isHistoryTab && searchTerm
              ? 'Essayez avec d\'autres mots-clés'
              : 'Les nouvelles réservations apparaîtront ici'
            }
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box>
      {isHistoryTab && (
        <BookingSearch 
          searchTerm={searchTerm} 
          onSearchChange={onSearchChange} 
        />
      )}
      {filteredBookings.map((booking) => (
        <BookingCard
          key={booking.id}
          booking={booking}
          showActions={showActions}
          onUpdateStatus={onUpdateStatus}
          onEdit={onEdit}
          onDelete={onDelete}
          onRejectWithReason={onRejectWithReason}
        />
      ))}
    </Box>
  );
};

export default BookingContent;